document.addEventListener('DOMContentLoaded', () => {
  const headings = document.querySelectorAll('.tabs-horizontal.headings > li');
  const content = document.querySelectorAll('.tabs.content > li');

  headings.forEach((heading, i) => {
    heading.addEventListener('click', () => {
      headings.forEach(tab => tab.classList.remove('active'));
      content.forEach(panel => panel.classList.remove('active'));

      heading.classList.add('active');
      content[i]?.classList.add('active');
    });
  });

  headings[0]?.click();
});